module.exports = __webpack_public_path__ + "static/media/miniwave-policie-dental.f008aa83.svg";